'use client';

import { PropsWithChildren, useEffect, useState } from 'react';
import { useTheme, ThemeProvider } from 'next-themes';
import { ConfigProvider, Spin, theme, ThemeConfig } from 'antd';
import themes from '@/utils/themes';
import styled from '@emotion/styled';
import { useStore } from '@/store/zustand-solicitud';
import { lighten, darken } from 'polished';

const LoadingPage = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;
  background: #000000;
`;

export const ThemesProvider = (props: PropsWithChildren) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return (
      <LoadingPage>
        <Spin />
      </LoadingPage>
    );
  }

  return (
    <ThemeProvider attribute="class" enableSystem disableTransitionOnChange>
      {props.children}
    </ThemeProvider>
  );
};

export const WithThemes = ({ children }: PropsWithChildren) => {
  const { color } = useStore();
  let customStyles = '';
  if (color) {
    const lightPrimaryColor = lighten(0.30, color); // Aclarar el color en un 20%
    const darkPrimaryColor = darken(0.2, color);

    customStyles = `
			:root {
				--primary-color: ${color};
				--light-primary-color: ${lightPrimaryColor};
        --darken-primary-color: ${darkPrimaryColor};
			}

		`;
  }
  const config: ThemeConfig = {
    token: {
      colorPrimary: color,
      colorText: '#000000',
      colorTextLightSolid: 'rgb(0 0 0 / 57%)',
      fontSize: 16,
    },
    components: {
      Steps: {
        customIconSize: 24,
        iconSize: 30,
        iconFontSize: 18,
        colorTextDescription: '#ffffffe6',
        colorSplit: 'rgb(255 255 255 / 70%)',
      },
      Button: {
        fontSize: 16,
        primaryColor: '#ffffffe6',
        defaultBg: 'rgb(0 0 0 / 0%)',
        colorTextDisabled: '#ffffffe6',
      },
      Select: {
        fontSize: 16,
        optionHeight: 40,
        colorText: '#000000',
      },
      Card: {
        colorBgContainer: '#ffffff',
        actionsBg: 'none',
      },
      Layout: {
        colorBgContainer: '#ffffffe6',
        bodyBg: '#ffffffe6',
      },
      Input: {
        colorText: '#000000',
        colorSuccessActive: '#000000',
        colorSuccessTextActive: '#000000',
      },
      DatePicker: {
        // colorBgElevated: '#000000',
        // colorTextLightSolid: '#000000',
        // colorTextHeading: '#000000',
        colorTextLabel: color,
        // cellWidth: 100,
      },
      Checkbox: {
        colorTextDisabled: '#d3c9c9e6',
      },
      Upload: {
        colorBgBase: '#fff5f5',
        actionsColor: '#f30101', // Ícono rojo
        colorText: '#f30101', // Texto en rojo
        colorError: '#f30101',
      },
      Tooltip: {
        colorBgSpotlight: '#ffffff',
        colorText: '#000000'
      }
    },
  };
  return (
    <ConfigProvider theme={config}>
      <style>{customStyles}</style>
      {children}
    </ConfigProvider>
  );
};
